import React from 'react';

// Styles
import './TypingDots.scss';

const TypingDots = () => {
  const baseClassName = 'TypingDots';
  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__dot`}></div>
      <div className={`${baseClassName}__dot`}></div>
      <div className={`${baseClassName}__dot`}></div>
    </div>
  );
};

export default TypingDots;
